module.exports = __webpack_public_path__ + "static/media/TUNE_4871.7c70382a.jpg";